import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

// Firebase configuration from Firebase Console
const firebaseConfig = {
    apiKey: "AIzaSyBVHQTwvmmPrWwbykUmMO1Jm0zfndDEU_I",
    authDomain: "achievement-report-449902.firebaseapp.com",
    projectId: "achievement-report-449902",
    storageBucket: "achievement-report-449902.firebasestorage.app",
    messagingSenderId: "442497047534",
    appId: "1:442497047534:web:48af58ca05a906b4a18cff",
    measurementId: "G-0D5Z5CTJJ1"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics, logEvent };
